<template>
    <div class="answer-birth-date answer-patient-info">

        <v-container v-if="getGoToGeneralQuestions" >
            <v-layout row>

                <v-flex xs10>
                    <v-dialog
                        :close-on-content-click="false"
                        v-model="menu2"
                        ref="dialog"
                        persistent
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                        <v-text-field
                            slot="activator"
                            v-model="computedDateFormatted"
                            :placeholder="text('api.chatbot.placeholder.patientBirthDate')"
                            prepend-icon="event"
                            readonly
                        ></v-text-field>
                        <v-date-picker v-model="date" ref="picker" class="text-center"  :max="year" min="1900" :first-day-of-week="1" locale="de">
                            <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{text('api.chatbot.btn.confirm')}}</v-btn>
                        </v-date-picker>
                    </v-dialog>

                </v-flex>

                <a @click.once="goToBirthDate" v-if="date && date.length" class="pf-date-send-arrow">
                    <img src="../../../../assets/send_active.png" alt="avatar">
                </a>
                <a  v-else class="pf-date-send-arrow">
                    <img src="../../../../assets/send_disabled.png" alt="avatar">
                </a>


            </v-layout>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AnswerBirthDate',
        data(){
            return {
                birthDate: '',
                birthDay: '',
                birthMonth:'',
                birthYear: '',
                max: 2,
                maxYear: 4,
                modal: false,
                date:null,
                dateFormatted: null,
                menu2: false,
                year:'',
                menu: false
                // validationRules: {
                //
                //         dayValidation: [
                //             (value) => /^\d*$/.test(value) || ''
                //         ],
                //         monthValidation: [],
                //         yearValidation: []
                //
                // }
            }
        },
        computed: {
            ...mapGetters({
                getGoToGeneralQuestions: 'ChatBotStore/getGoToGeneralQuestions'
            }),
            computedDateFormatted () {
                return this.formatDate(this.date)
            }
        },

        mounted() {
            let currentYear = new Date().getFullYear();
            this.year = currentYear.toString();
        },
        watch: {
            birthDay(newValue, oldValue) {
                if(newValue.length === 2) {
                    this.$refs.monthField.focus()
                }
            },
            birthMonth(newValue, oldValue) {
                if(newValue.length === 2) {
                    this.$refs.yearField.focus()
                }
            },
            menu2 (val) {
                console.log("dialog")
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            date (val) {
                this.dateFormatted = this.formatDate(this.date)
            },

            getGoToGeneralQuestions(newVal, oldVal) {

                if (newVal === true) {

                    this.$nextTick(function () {
                        this.$emit('onAnswerListUpdated');
                    });
                }

            }
        },


        methods: {

            goToBirthDate() {
                this.$store.commit('ChatBotStore/setPatientBirthDate', this.dateFormatted);
                this.$store.dispatch("ChatBotStore/selectBirthDate", {
                    fieldName: "BIRTHDAY",
                    fieldValue: this.dateFormatted
                });
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

        .picker.picker--date.card {
            padding: 0 !important;
        }


        .pf-date-send-arrow {
            position: relative;
            top: 22px;
            left: 35px;
        }

        .chatbot-patient-info .input-group.input-group-focused .input-group--append-icon {
            color: $color-body-text
        }

    .answer-birth-date.answer-patient-info {
        .container {
            padding-top: 10px !important;
            padding-bottom: 10px !important;

            .flex {
                position: relative;
                max-height: 70px;

                span {
                    position: relative;
                    bottom: 33px;
                    left: 30px;
                }
            }
        }
    }

</style>






// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerBirthDate.vue